import './ButtonWithLoading.styles.scss';

import React from 'react';
import { Button } from '@material-ui/core';

import loadingImg from '../../assets/imgs/icons/loading.gif';

const ButtonWithLoading = ({
	isSubmitting,
	btnText,
	loadingMsg,
	errors,
	...rest
}) => {
	// console.log(errors);
	const errorObjIsEmpty = errors ? Object.keys(errors).length === 0 : true;

	return (
		<Button
			type="submit"
			color="primary"
			variant="contained"
			disabled={isSubmitting || !errorObjIsEmpty}
			className="btnWithLoading"
			{...rest}
		>
			{isSubmitting ? (
				<>
					<img className="loadingImg" src={loadingImg} alt="img" />
					{loadingMsg}
				</>
			) : (
				btnText
			)}
		</Button>
	);
};

export default ButtonWithLoading;
